import useModal from '@fipnooone/react-modal';
import React, { useEffect, useState } from 'react';

import { Api } from '@.api';
import { StationFirmwareResponse } from '@.api/methods';
import { DeviceResource } from '@/entities/Device/api';
import { StationResource } from '@/entities/Station';

import { calculateUpdateLicenseKeyStrategyByTechnicalMode } from '../../../model/calculateUpdateLicenseKeyStrategyByTechnicalMode';
import { stationDetailStoreSelectors } from '../../../model/StationDetailStore';
import { UpdateLicenseKeyStrategyEnum } from '../../../model/UpdateLicenseKeyStrategy';
import { EditLicenseKeyHttpModal, EditLicenseKeySocketModal } from './components';

export const useFirmware = (station?: StationResource) => {
    const [firmware, setFirmware] = useState<StationFirmwareResponse | null>();

    const [modal, controls] = useModal();

    const stationTechnicalMode = stationDetailStoreSelectors.use.stationTechnicalMode();

    const updateLicenseKeyStrategy = calculateUpdateLicenseKeyStrategyByTechnicalMode(stationTechnicalMode);

    useEffect(() => {
        if (!station?.id) {
            return;
        }

        Api.stations()
            .getFirmware(station.id)
            .onSuccess((res) => setFirmware(res.data));
    }, [station?.id]);

    const updateDevice = (device: DeviceResource): void => {
        if (!firmware) {
            throw new Error('firmware not exists');
        }

        const devices = firmware.devices.map((deviceItem) => {
            if (deviceItem.id === device.id) {
                return device;
            }

            return deviceItem;
        });

        setFirmware({
            ...firmware,
            devices,
        });
    };

    const updateLicenseKey = (deviceId: number, licenseKey: string): void => {
        if (!firmware) {
            throw new Error('firmware not exists');
        }

        const nextDeviceState = firmware.devices.map((device) => {
            if (device.id === deviceId) {
                return {
                    ...device,
                    license_key: licenseKey,
                };
            }

            return device;
        });

        setFirmware({
            ...firmware,
            devices: nextDeviceState || [],
        });
    };

    const showEditLicenseKeyModal = (device: DeviceResource) => {
        const commonProps = {
            device,
            deviceId: device.id,
            licenseKeyInitial: device.license_key || '',
            licenseKeyStatus: device.license_key_status,
        };

        if (updateLicenseKeyStrategy === UpdateLicenseKeyStrategyEnum.HTTP) {
            controls.set(<EditLicenseKeyHttpModal {...commonProps} updateDevice={updateLicenseKey} />);
        } else {
            controls.set(<EditLicenseKeySocketModal {...commonProps} updateDeviceLicenseKey={updateLicenseKey} />);
        }
    };

    return {
        firmware,
        modal,
        updateDevice,
        showEditLicenseKeyModal,
    };
};
